module.exports = __webpack_public_path__ + "static/logo-littlespoon-fbcbef4789846174b0984fb37321f45a.png";